/**
 * Ease My Bill brand assets — served from /app/frontend/public/brand/.
 * Public path so we can reference them by URL from anywhere.
 */

// Public URLs (CRA serves everything under public/ at the site root)
export const LogoFullSrc = '/brand/logo-full.png';
export const LogoIconSrc = '/brand/logo-icon.png';

/**
 * <Logo /> — the brand mark.
 *
 * Props:
 *  - variant: "icon" (square hex mark) | "full" (icon + wordmark). Default "icon".
 *  - size: pixel height. Default 36 for icon, 32 for full.
 *  - className: extra classes for the <img>.
 */
export function Logo({ variant = 'icon', size, className = '', ...rest }) {
    const src = variant === 'full' ? LogoFullSrc : LogoIconSrc;
    const h = size ?? (variant === 'full' ? 32 : 36);
    return (
        <img
            src={src}
            alt="Ease My Bill"
            height={h}
            style={{ height: h, width: 'auto' }}
            className={`select-none ${className}`}
            draggable={false}
            {...rest}
        />
    );
}
